import React, { useState } from 'react'
import { useGoogleLogin } from '@react-oauth/google';
import { ApiPostCallAuthKey, ApiPostLoginCall } from '../JS/Connector';
import {  HideLoder, ShowLoder } from '../JS/Common';
import { log } from '../JS/Logger';
import { useDispatch } from 'react-redux';
import { setCsvUserID, setHelpTicketDetails, setJwtToken, setSchoolId, setSupportTicketDetails, setUserId } from '../Store/Slices/authSlice';
import { hasRoleAccess, RoleEnum } from '../JS/RoleType';
import useConfig from '../Hooks/useConfig';

export default function GoogleOauth(props) {
    const { enterprise_flag } = useConfig();
    const [loading, setLoading] = useState(false);
    const reduxDispatch = useDispatch();
    const login = useGoogleLogin({
        flow: 'auth-code',
        onSuccess: response => { fetchUserProfile(response) },
        accessType: 'offline',
        responseType: "code",
        prompt: 'consent',
        fetchBasicProfile: true,
    });
    const fetchUserProfile = async (response) => {
        try {
            if (!response) {
                log.error('Failed to fetch user profile');
                return;
            }
            if (props.flag == "signin") {
                onSigninSuccess(response);
            } else if (props.pageflag == "helpdesk") {
                onHelpdeskSuccess(response);
            } else {
                onSupportTicketSuccess(response);
            }
        } catch (error) {
            log.error('Error fetching user profile:', error);
        }
    };
    const onSigninSuccess = async (res) => {
        setLoading(true)
        var raw = JSON.stringify({
            googleId: res.code,
            microsoftId: null,
            flag: 1,
            enterpriseFlag: enterprise_flag
        });
        await ApiPostLoginCall("/login", raw, true).then((result) => {
            if (result == undefined || result == "") {
                log.error('Login Failed!');
            } else {
                const responseRs = JSON.parse(result.data);
                setLoading(false)
                if (responseRs.status == "success") {
                    const expires = 1;
                    const authHeader = result?.headers?.authorization || '';
                    const headerToken = authHeader.startsWith('Bearer ') ? authHeader.slice(7) : authHeader;
                    const jwtToken = headerToken || null;
                    reduxDispatch(setJwtToken(jwtToken));
                    reduxDispatch(setUserId(responseRs?.msg?.id));
                    reduxDispatch(setCsvUserID(responseRs.msg.id));
                    reduxDispatch(setSchoolId(responseRs.msg.school_id));
                    props.alertcolor("green");
                    props.alertmsg(`Authentication successfull! Redirecting to the home page...`);
                    setTimeout(() => {
                        const userRoleKey = responseRs.msg?.accesstype || null;
                        if (hasRoleAccess(userRoleKey, RoleEnum.ALL_ADMINS)) {
                            window.location = '/school-tickets';
                        } else {
                            window.location.href = '/';
                        }
                    }, 1500);
                }
                else {
                    props.alertcolor("red");
                    props.alertmsg(responseRs.response);
                }
            }

        });
    }
    const onSupportTicketSuccess = async (res) => {
        var raw = JSON.stringify({
            schoolNumber: props.schoolnumber,
            googleId: res.code,
            ssoId: null,
            flag: 1,
        })
        await ApiPostCallAuthKey("/auth/sso-validation", raw).then((result) => {
            if (result == undefined || result == "") {
                log.error('Login Failed!');
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false)
                if (responseRs.status == "success") {
                    const expires = 1;
                    props.alertcolor('green')
                    props.alertmsg(responseRs.msg)
                    setTimeout(function () {
                        props.setLoginFlag(0)
                    }, 2500);
                }
                else {
                    props.alertcolor('red')
                    props.alertmsg(responseRs.msg)
                }
            }
        });
    }
    const onHelpdeskSuccess = async (res) => {
        var raw = JSON.stringify({
            schoolNumber: props.schoolnumber,
            googleId: res.code,
            ssoId: null,
            flag: 1,
        })
        await ApiPostCallAuthKey("/auth/helpdesk-validation", raw).then((result) => {
            if (result == undefined || result == "") {
                log.error('Login Failed!');
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false)
                if (responseRs.status == "success") {
                    const expires = 1;
                    props.alertcolor('green')
                    props.alertmsg(responseRs.msg)
                    setTimeout(function () {
                        props.setLoginFlag(0)
                    }, 2500);
                }
                else {
                    props.alertcolor('red')
                    props.alertmsg(responseRs.msg)
                }
            }
        });
    }
    return (
        <div>
            {loading ? <ShowLoder /> : <HideLoder />}
            <button onClick={() => login()} className="MicrosoftGoogleBtn">
                <img src="/images/GoogleBtn.svg" className="img-fluid pe-2" /> Connect with Google
            </button>
        </div>
    )
}
